import { render, staticRenderFns } from "./ProductInfoView.vue?vue&type=template&id=3d36b284&"
import script from "./ProductInfoView.vue?vue&type=script&lang=js&"
export * from "./ProductInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports